import { useMemo } from 'react'
import { CustomFieldValue } from '../context/CustomField/CustomFieldTypes'

interface UseTransformCustomFieldValuesProps {
    data: Array<CustomFieldValue>
}

export default function useTransformCustomFieldValues({ data }: UseTransformCustomFieldValuesProps) {
    return useMemo(() => {
       if (!data) return []
       if (!Array.isArray(data)) return []
       return data.map(dropDownValue => dropDownValue.key)
    }, [data])
}